<template>
  <div class="TheLogoComponent">
    <img :style="[logoWidth]" class="dho-logo" :src="logoImage" alt="DHO Consulting Logo"/>
  </div>
</template>

<script>
  import LogoImage from '../../assets/images/logo-shadow-stroke.png'

  export default {
    name: 'TheLogo',
    components: {},
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
      width: {
        type: String,
        default: '100%'
      }
    },
    computed: {
      logoWidth: function () {
        return {
          'width': this.width
        }
      }
    },
    watch: {},
    mixins: [],
    data: function () {
      return {
        logoImage: LogoImage
      }
    },
    methods: {},
    created () {
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .TheLogoComponent {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;

    img.dho-logo {
      width: 100%;
      height: auto;
      max-width: 500px;
    }
  }
</style>
